import React, { lazy,  } from 'react'
import { Redirect, Route, } from 'react-router'
import PrivateRoute from '../../auth/PrivateRoute'
import Header from '../header/Header'
import ProfileEdit from '../../pages/user/profile/ProfileEdit'
import Profile from '../../pages/user/profile/Profile'
import Changepassword from '../user/ChangePassword'
import TransactionLog from '../flights/transactionlog/TransactionLog'
import HotelVoucher from '../hotel/reports/voucher/HotelVoucher'
import FlightRoutes from '../flights/FlightRoutes'
import AccountLedger from '../flights/accountledger/AccountLedger'
import PageNotFound from '../PageNotFound'
import HotelDetails from '../hotel-details/HotelDetails'
import HotelBooking from '../hotel-details/HotelBooking'
import ActivityDetails from '../activities/activity-details/ActivityDetails'

// const FlightRoutes = lazy(() => import('../flights/FlightRoutes'))
// const AccountLedger = lazy(() => import('../flights/accountledger/AccountLedger'))
const FlightReport = lazy(() => import('../flights/reports/FlightReport'))
const Eticket = lazy(() => import('../flights/reports/Eticket'))
const Bankdetails = lazy(() => import('../flights/bankdetails/Bankdetails'))
const Setbalance = lazy(() => import('../flights/bankdetails/Setbalance'))
const Commission = lazy(() => import('../flights/commision/Commission'))
const ManageGst = lazy(() => import('../flights/gst/ManageGst'))
const Gstdetails = lazy(() => import('../flights/gst/Gstdetails'))
const FlightMarkup = lazy(() => import('../flights/markup/FlightMarkup'))
const InvoiceTable = lazy(() => import('../flights/reports/invoice/InvoiceTable'))
const Voucher = lazy(() => import('../flights/reports/voucher/Voucher'))
const Calendar = lazy(() => import('../calendar/Calendar'))
const AirPassengerCalendar = lazy(() => import('../calendar/AirPassengerCalendar'))
const SendBalance = lazy(() => import('../balance/SendBalance'))
const UpdateGst = lazy(() => import('../flights/gst/UpdateGst'))
const UpdateBalance = lazy(() => import('../balance/UpdateBalance'))
const Cancellation = lazy(() => import('../flights/reports/cancellation/Cancellation'))
const FlightCancellationDetails = lazy(() => import('../flights/reports/cancellation/FlightCancellationDetails'))
const RefundnCancellation = lazy(() => import('../flights/reports/cancellation/RefundnCancellation'))
const InvoiceTableRefund = lazy(() => import('../flights/reports/invoice/InvoiceTableRefund'))
const Reschedule = lazy(() => import('../flights/reports/cancellation/Reschedule'))
const VoucherNew = lazy(() => import('../flights/reports/voucher/VoucherNew'))
const InvoiceNew = lazy(() => import('../flights/reports/invoice/InvoiceNew'))
const UploadLogo = lazy(() => import('../logo/UploadLogo'))
const QueueLayoutReschedule = lazy(() => import('../queue/QueueLayoutReschedule'))
const QueueLayoutCancellation = lazy(() => import('../queue/QueueLayoutCancellation'))
const HotelReport = lazy(() => import('../hotel/reports/HotelReport'))
// const HotelVoucher = lazy(() => import('../hotel/reports/voucher/HotelVoucher'))
const HotelInvoice = lazy(() => import('../hotel/reports/invoice/HotelInvoice'))
const TopUpRecharge = lazy(() => import('../topuprecharge/TopUpRecharge'))
const Success = lazy(() => import('../topuprecharge/Success'))
const Failed = lazy(() => import('../topuprecharge/Failed'))
const HotelRoutes = lazy(() => import('../hotels/HotelRoutes'))
const HotelCancellation = lazy(() => import('../hotel/reports/cancellation/HotelCancellation'))
const HotelCancellationDetails = lazy(() => import('../hotel/reports/cancellation/HotelCancellationDetails'))
const HotelRefundnCancellation = lazy(() => import('../hotel/reports/cancellation/HotelRefundnCancellation'))
const HotelCancellationQueue = lazy(() => import('../queue/HotelCancellationQueue'))
const HotelCreditNote = lazy(() => import('../hotel/reports/invoice/HotelCreditNote'))
const HotelMarkup = lazy(() => import('../hotels/markup/HotelMarkup'))
const Payment = lazy(() => import('../payment/Payment'))

const Home = () => {
  return (
        <div className="Main-content-box">
            <div className="Main-content-header">
                <Header />
            </div>
            <div className="flight-searschi-n-carousel">

                <Route exact path="/">
                    <Redirect to="/flight" />
                </Route>
                <PrivateRoute path="/flight" component={FlightRoutes} />
                <PrivateRoute exact path="/profile" component={Profile}></PrivateRoute>
                <PrivateRoute exact path="/edit-profile" component={ProfileEdit}></PrivateRoute>
                <PrivateRoute exact path="/change-password" component={Changepassword}></PrivateRoute>

                <PrivateRoute path="/accountledger" component={AccountLedger} />
                <PrivateRoute path="/transactionlog" component={TransactionLog} />
                <PrivateRoute path="/flight-report" component={FlightReport} />
                <PrivateRoute path="/eticket" component={Eticket} />
                <PrivateRoute path="/bankdetails" component={Bankdetails} />
                <PrivateRoute path="/setbalance" component={Setbalance} />
                {/* <PrivateRoute path="/commission" component={Commission} /> */}
                <PrivateRoute path="/markup" component={FlightMarkup} />
                <PrivateRoute path="/manage-gst" component={ManageGst} />
                <PrivateRoute path="/view-gst" component={Gstdetails} />
                <PrivateRoute path="/voucher" component={Voucher} />
                <PrivateRoute path="/invoice" component={InvoiceTable} />

                <PrivateRoute path="/update-gst" component={UpdateGst} />
                <PrivateRoute path="/updatebalance" component={UpdateBalance} />
                <PrivateRoute path="/sendbalance" component={SendBalance} />

                <PrivateRoute path="/cancellation" component={Cancellation} />
                <PrivateRoute path="/refund-details" component={RefundnCancellation} />
                <PrivateRoute path="/credit-note" component={InvoiceTableRefund} />
                <PrivateRoute path="/cancellation-details" component={FlightCancellationDetails} />
                <PrivateRoute path="/reschedule" component={Reschedule} />
                <PrivateRoute path="/new-voucher" component={VoucherNew} />
                <PrivateRoute path="/new-invoice" component={InvoiceNew} />
                <PrivateRoute path="/upload-logo" component={UploadLogo} />
                <PrivateRoute path="/reschedule-queue" component={QueueLayoutReschedule} />
                <PrivateRoute path="/cancellation-queue" component={QueueLayoutCancellation} />

                <PrivateRoute path="/hotel-report" component={HotelReport} />
                <PrivateRoute path="/hotel-voucher" component={HotelVoucher} />
                <PrivateRoute path="/hotel-invoice" component={HotelInvoice} />
                <PrivateRoute path="/hotel-cancellation" component={HotelCancellation} />
                <PrivateRoute path="/hotel-cancellation-details" component={HotelCancellationDetails} />
                <PrivateRoute path="/hotel-refund-details" component={HotelRefundnCancellation} />
                <PrivateRoute path="/hotel-cancellation-queue" component={HotelCancellationQueue} />
                <PrivateRoute path="/hotel-credit-note" component={HotelCreditNote} />
                <PrivateRoute path="/top-up-recharge" component={TopUpRecharge} />
                <PrivateRoute path="/payment-Success" component={Success} />
                <PrivateRoute path="/payment-Failed" component={Failed} />
                <PrivateRoute path="/hotel" component={HotelRoutes} />
                <PrivateRoute path="/hotel-markup" component={HotelMarkup} />

                <Route path="/hotel-details" component={HotelDetails} />
                <Route path="/hotel-booking" component={HotelBooking} />

                <PrivateRoute path="/payment" component={Payment} />

                {/* <PrivateRoute path="/activity-details" component={ActivityDetails} /> */}
                {/* <PrivateRoute path="*" component={PageNotFound} /> */}

               
                {/* <Route path="/not-found" component={PageNotFound} />
                <Redirect to="/not-found" /> */}


            </div>
        </div>
  )
}

export default Home
